const Italian = require("flatpickr/dist/l10n/it").default.it;

const flatpickrOptions = {
    "locale": Italian,
    altInput: true,
    altFormat: "d/m/Y",
    dateFormat: "Y-m-d",
    disableMobile: "true",
    onReady: function(selectedDates, dateStr, instance) {
        let el = instance.altInput;
        el.classList.remove("flatpickr")
        el.classList.add("generated-flatpickr")
    },
}

function initFlatpickr() {
    $('.flatpickr').each(function() {
        let $this = $(this);
        // Controlla se l'input ha già un'istanza di Flatpickr
        if (!$this[0]._flatpickr) {
            $this.flatpickr(flatpickrOptions);
        } else {
            console.log("Flatpickr già inizializzato su questo input", $this);
        }
    });
}

export { flatpickrOptions, initFlatpickr }